import React, { useEffect, useState } from "react"
import Form from 'react-bootstrap/Form';
import ReactPaginate from 'react-paginate';

const ListsPagination = (props) => {
    const { fetchData, dataCount, defaultItemsPerPage, defaultSelectedPage} = props
    const [itemsPerPage, setItemsPerPage] = useState(defaultItemsPerPage ?? 10);
    const [itemOffset, setItemOffset] = useState(null);
    const [selectedPage, setSelectedPage] = useState(defaultSelectedPage ? defaultSelectedPage : 0);
    const [pageCount, setPageCount] = useState(0);
    const [isInitialCall, setIsInitialCall] = useState(true)

    useEffect(() => {
        if (fetchData) {
            setIsInitialCall(false)
            fetchData(selectedPage +1, itemsPerPage , isInitialCall)
            setPageCount(Math.ceil(dataCount / itemsPerPage))
            return;
        }
    }, [itemOffset, itemsPerPage, dataCount]);


    const itemPerChangeHandler = (count) => {
        setItemsPerPage(count)
        setItemOffset(0)
        setSelectedPage(0)
    }

    const handlePageClick = (event) => {
        const newOffset = (event.selected) * itemsPerPage % (dataCount);
        setItemOffset(newOffset);
        setSelectedPage(event.selected)
    };
  return (
    <div className="d-flex align-items-center justify-content-end">
        <div className="d-flex">
            Select Limit :
            <Form className="ms-3">
                {['radio'].map((type) => (
                    <div key={`inline-${type}`} className="mb-3">
                        <Form.Check
                            inline
                            label="10"
                            name="group1"
                            type={type}
                            id={`inline-${type}-1`}
                        >
                            <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value == "on" && itemPerChangeHandler(10)} checked={itemsPerPage == 10} />
                            <Form.Check.Label >10</Form.Check.Label>
                        </Form.Check>
                        <Form.Check
                            inline
                            name="group1"
                            type={type}
                        >
                            <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value == "on" && itemPerChangeHandler(25)} checked={itemsPerPage == 25} />
                            <Form.Check.Label >25</Form.Check.Label>
                        </Form.Check>
                        <Form.Check
                            inline
                            label="50"
                            name="group1"
                            type={type}
                            id={`inline-${type}-3`}
                        >
                            <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value == "on" && itemPerChangeHandler(50)} checked={itemsPerPage == 50} />
                            <Form.Check.Label >50</Form.Check.Label>
                        </Form.Check>
                        <Form.Check
                                inline
                                label="100"
                                name="group1"
                                type={type}
                                id={`inline-${type}-4`}
                            >
                                <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value === "on" && itemPerChangeHandler(100)} checked={itemsPerPage === 100} />
                                <Form.Check.Label>100</Form.Check.Label>
                            </Form.Check>
                            <Form.Check
                                inline
                                label="150"
                                name="group1"
                                type={type}
                                id={`inline-${type}-5`}
                            >
                                <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value === "on" && itemPerChangeHandler(150)} checked={itemsPerPage === 150} />
                                <Form.Check.Label>150</Form.Check.Label>
                            </Form.Check>

                    </div>
                ))}
            </Form>
        </div>
        <ReactPaginate
            nextLabel=">>"
            onPageChange={(e) => handlePageClick(e)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={pageCount}
            forcePage={selectedPage}
            previousLabel="<<"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName="active"
            renderOnZeroPageCount={null}
        />
    </div> 
  )
};

export default ListsPagination;